import { createSlice } from '@reduxjs/toolkit'

import { ITemplate } from 'omnicom/models/ITemplate'

export interface IOmniState {
  activeTemplate: ITemplate | null
}

const initialState: IOmniState = {
  activeTemplate: null,
}

const OmniSlice = createSlice({
  name: '@omni',
  initialState: initialState,
  reducers: {
    setActiveTemplate: (state, action) => {
      state.activeTemplate = action.payload
    },
  },
})

export const { setActiveTemplate } = OmniSlice.actions

export default OmniSlice.reducer
